import { fetch } from '@/common/request';

export interface LoginInfo {
  username: string;
  password: string;
}

export interface UserVo {
  id?: number;
  username?: string;
  password?: string;
  name?: string;
  createTime?: string;
}

export function login(params: LoginInfo): Promise<any> {
  return fetch(
    '/api/login',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export function logout(): Promise<any> {
  return fetch(
    '/api/login/out',
    {
      method: 'POST',
    },
    true
  );
}
export function getUserInfo(): Promise<UserVo> {
  return fetch(
    '/api/user/info',
    {
      method: 'POST',
    },
    true
  );
}

// 用户列表
export function getUserList(): Promise<UserVo[]> {
  return fetch(
    '/api/user/list',
    {
      method: 'POST',
    },
    true
  );
}

// 新增用户
export function saveUser(params: UserVo): Promise<any> {
  return fetch(
    '/api/user/save',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
// 修改用户
export function updateUser(params: UserVo): Promise<any> {
  return fetch(
    '/api/user/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// 删除用户
export function deleteUser(id: number): Promise<any> {
  return fetch(
    '/api/user/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}
